module.exports = __webpack_public_path__ + "static/media/Volumen_alto.1a659570.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Volume/Volumen_alto.svg
// module id = 1853
// module chunks = 0